import React from "react";
import Attachments from "../../Pfizer/form/formSections/attachments";

export const AttachmentsField = () => {
  const showDivider = false;
  return (
    <div>
      <Attachments showDivider={showDivider} />
    </div>
  );
};
